import gql from 'graphql-tag'

export const CHANGE_PASSWORD_MUTATION = gql`
mutation passwordChange($oldPassword: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordChange(oldPassword: $oldPassword, newPassword1: $newPassword1, newPassword2: $newPassword2) {
    success
    errors
  }
}
`


export const RESET_PASSWORD_MUTATION = gql`
mutation passwordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordReset(token: $token, newPassword1: $newPassword1, newPassword2: $newPassword2) {
    success
    errors
  }
}
`


export const SEND_PASSWORD_RESET_MUTATION = gql`
mutation sendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors
  }
}
`
